<template>
  <a-list v-if="listData" item-layout="horizontal" :data-source="listData" style="background: #fff">
    <div slot="header" style="font-weight: 600; color: #096dd9">{{ title }}</div>

    <a-list-item slot="renderItem" slot-scope="item">
      <a-list-item-meta>
        <a slot="title">{{ item.title }}</a>

        <div slot="description" style="font-size: 12px; margin-top: -4px">
          编辑时间：{{ item.description }}
        </div>
      </a-list-item-meta>
    </a-list-item>
  </a-list>
</template>

<script>
export default {
  name: 'ListTooltip',
  props: {
    listData: Array,
    title: String
  }
}
</script>

<style lang="less" scoped></style>
